import type { ComponentType } from "react";
import StatusChipComponent from "./StatusChip.jsx";

const StatusChip = StatusChipComponent as ComponentType<any>;
export default StatusChip;
